<template>
  <div class="flex items-center" >
    <div v-for="(rol, index) in rolesArray" :key="index">
      <vs-avatar text="Fase1" :title="rol" color="primary" v-if="rol === 'Cliente Fase de Evaluación'"/>
      <vs-avatar text="Fase2" :title="rol" color="success" v-if="rol === 'Cliente Fase de Análisis'"/>
      <vs-avatar text="Fase3" :title="rol" color="danger" v-if="rol === 'Cliente Fase de Ejecución'"/>
      <vs-avatar text="Fase4" :title="rol" color="warning" v-if="rol === 'Cliente Fase de Asesoramiento Integral'"/>
      <vs-avatar text="NIE" :title="rol" color="warning" v-if="rol === 'Cliente Extranjería Primera Residencia'"/>
      <vs-avatar text="RNIE" :title="rol" color="warning" v-if="rol === 'Cliente Extranjería Renovación'"/>
      <vs-avatar text="RNIE" :title="rol" color="warning" v-if="rol === 'Cliente Extranjería Renovación de Primera Residencia'"/>
      <vs-avatar text="DNI" :title="rol" color="warning" v-if="rol === 'Cliente Extranjería Ciudadanía'"/>
      <vs-avatar text="Premium" :title="rol" color="dark" v-if="rol === 'Usuario Premium mayor 6 meses'"/>
      <vs-avatar text="Premium" :title="rol" color="dark" v-if="rol === 'Usuario Premium menor 6 meses'"/>
      <vs-avatar text="Reg" :title="rol" color="dark" v-if="rol === 'Cliente Registrado'"/>
      <vs-avatar text="Reg" :title="rol" color="dark" v-if="rol === 'Usuario Lite'"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CellRendererRoles',
  computed: {
    rolesArray () {
      return this.params.value.map(item => item.name_role)
    }
  }
}
</script>

<style scoped>
</style>
